/**
 * @generated SignedSource<<bfae388861992665552516bb8499e499>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TodoStatus = "DONE" | "PENDING";
import { FragmentRefs } from "relay-runtime";
export type TodoTimelineUpdateEvent_event$data = {
  readonly __typename: string;
  readonly newStatus?: TodoStatus;
  readonly " $fragmentSpreads": FragmentRefs<"TodoTimelineUpdateEventBody_event" | "TodoTimelineUpdateEventIcon_event">;
  readonly " $fragmentType": "TodoTimelineUpdateEvent_event";
};
export type TodoTimelineUpdateEvent_event$key = {
  readonly " $data"?: TodoTimelineUpdateEvent_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoTimelineUpdateEvent_event">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoTimelineUpdateEvent_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoTimelineUpdateEventIcon_event"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoTimelineUpdateEventBody_event"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "newStatus",
          "storageKey": null
        }
      ],
      "type": "TodoTimelineUpdateEventStatus",
      "abstractKey": null
    }
  ],
  "type": "TodoTimelineUpdateEvent",
  "abstractKey": "__isTodoTimelineUpdateEvent"
};

(node as any).hash = "19f6a9f7d9ec3c6e47ec45a20f57f17b";

export default node;
